import { useCurrentWorkspace } from '@/providers/WorkspaceProvider';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import { useNavState } from '@/providers/NavStateProvider';
import { useEffect } from 'react';
import { MenuButtonGroup } from '@/components/features/SettingMenuButtonGroup';
import { WorkspaceLayout } from '@/components/layout/WorkspaceLayout';
import { ScrollTop } from '@/components/element/ScrollTop';
import { useMonthlyExternalExpenses } from '@/hooks/api/2430_monthly_external_expenses';
import { MonthlyExternalExpenseElement } from '@/features/w/[identifier]/setting/edit_monthly_external_expenses/{components}/MonthlyExternalExpenseElement';

export const EditMonthlyExternalExpenses = () => {
  const { _w_, me } = useCurrentWorkspace();

  if (me?.admin) {
    return <_EditMonthlyExternalExpenses />;
  } else {
    return <Navigate replace to={'/workspaces'} />;
  }
};

const _EditMonthlyExternalExpenses = () => {
  const { setTitle, setBreadcrumbs } = useNavState();
  useEffect(() => setTitle('Node管理外費用編集'), []);
  useEffect(() => setBreadcrumbs([{ label: `スペース設定`, path: `/w/${_w_!.identifier}/setting` }]), []);

  const navigate = useNavigate();
  const { _w_, me } = useCurrentWorkspace();
  const { data } = useMonthlyExternalExpenses({ identifier: _w_!.identifier });

  return (
    <WorkspaceLayout>
      <ScrollTop />
      <div className="container-fluid py-4">
        <MenuButtonGroup selected={'basic'} />

        <div className="row">
          <div className="col-12 col-lg-12 mx-auto">
            <div className="card mb-4" id="basic-info">
              <div className="card-header d-flex align-items-center">
                <div className="col-md-8">
                  <h5 className="mb-1">Node管理外費用</h5>
                  <p className="text-xs mb-0">各月のNode管理外費用額を数値で設定してください。</p>
                </div>
              </div>
              <form>
                <div className="card-body pt-0">
                  <hr className="horizontal dark mb-5" />
                  <div className="row">
                    <div className="col-12 col-md-6 col-lg-4">
                      <div className="text-xs text-dark font-weight-bold mb-2">前期</div>
                      <div className="table-responsive">
                        <table className="table align-items-center">
                          <thead>
                            <tr>
                              <th
                                className="text-secondary text-xxs font-weight-bolder opacity-7 px-2"
                                style={{ width: 60 }}
                              >
                                対象年月
                              </th>
                              <th className="text-secondary text-xxs font-weight-bolder opacity-7 px-2 text-end">
                                金額
                              </th>
                              <th className="text-secondary opacity-7" style={{ width: 100 }}></th>
                            </tr>
                          </thead>
                          <tbody>
                            {data?.previous_external_expenses.map((d, i) => (
                              <MonthlyExternalExpenseElement key={`p-ee-${i}`} monthlyExternalExpense={d} />
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-4">
                      <div className="text-xs text-dark font-weight-bold mb-2">今期</div>
                      <div className="table-responsive">
                        <table className="table align-items-center">
                          <thead>
                            <tr>
                              <th
                                className="text-secondary text-xxs font-weight-bolder opacity-7 px-2"
                                style={{ width: 60 }}
                              >
                                対象年月
                              </th>
                              <th className="text-secondary text-xxs font-weight-bolder opacity-7 px-2 text-end">
                                金額
                              </th>
                              <th className="text-secondary opacity-7" style={{ width: 100 }}></th>
                            </tr>
                          </thead>
                          <tbody>
                            {data?.current_external_expenses.map((d, i) => (
                              <MonthlyExternalExpenseElement key={`c-ee-${i}`} monthlyExternalExpense={d} />
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-4">
                      <div className="text-xs text-dark font-weight-bold mb-2">来期</div>
                      <div className="table-responsive">
                        <table className="table align-items-center">
                          <thead>
                            <tr>
                              <th
                                className="text-secondary text-xxs font-weight-bolder opacity-7 px-2"
                                style={{ width: 60 }}
                              >
                                対象年月
                              </th>
                              <th className="text-secondary text-xxs font-weight-bolder opacity-7 px-2 text-end">
                                金額
                              </th>
                              <th className="text-secondary opacity-7" style={{ width: 100 }}></th>
                            </tr>
                          </thead>
                          <tbody>
                            {data?.next_external_expenses.map((d, i) => (
                              <MonthlyExternalExpenseElement key={`n-ee-${i}`} monthlyExternalExpense={d} />
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-footer d-flex align-items-center justify-content-end pt-0">
                  <Link to="" className="btn btn-outline-secondary me-2" onClick={() => navigate(-1)}>
                    戻る
                  </Link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </WorkspaceLayout>
  );
};
